/* ADD GROUPS */
export const LIST_REPORT1 = "LIST_REPORT1"
export const LIST_REPORT1_SUCCESS = "LIST_REPORT1_SUCCESS"
export const LIST_REPORT1_CLEAN = "LIST_REPORT1_CLEAN"
export const LIST_REPORT1_ERROR = "LIST_REPORT1_ERROR"
